// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".badge[data-v-765b521e]{background-color:#fa3e3e;border-radius:2rem;color:#fff;padding:0 7px;font-size:10px;position:absolute;top:0;right:0}.menu-item-basket a[data-v-765b521e]{padding:0 8px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
